import React from 'react'
import { string, number, shape, any } from 'prop-types'
import { routerPropTypes } from 'Types'
import { Link, Icon } from 'Blocks'
import { Helmet } from 'react-helmet-async'
import { getPaginationRels, UrlBuilder } from 'Utils'
import config from 'Config'

const {
  pagination: { prevIcon, nextIcon }
} = config
const Pagination = ({ className = '', pagination, location }) => {
  const queryString = location.search
  const urlBuilder = new UrlBuilder(queryString)
  const urlBuilder2 = new UrlBuilder(queryString)
  const currentPage = urlBuilder.getPage()

  const PaginationProps = {
    location,
    totalPages: pagination.total
  }

  const paginationRelLinks = getPaginationRels(PaginationProps)

  const RenderPagination = () => {
    if(!config.theme) {
      return (
        <div className={`pagination ${className}`}>
          <Helmet>{paginationRelLinks}</Helmet>
          <div>
            {pagination.previous && (
              <Link
                className="prev-button"
                to={urlBuilder.setPage(pagination.previous).getQueryString()}
              >
                {prevIcon ? <Icon name={prevIcon} /> : '<'}
              </Link>
            )}
          </div>
          <div className="paginate-text">
            {currentPage}&nbsp;{<span>of</span>}&nbsp;{pagination.pages}
          </div>
          {currentPage < pagination.pages && (
            <div>
              <Link
                className="next-button"
                to={urlBuilder2.setPage(pagination.next).getQueryString()}
              >
                {nextIcon ? <Icon name={nextIcon} /> : '>'}
              </Link>
            </div>
          )}
        </div>
      )
    } else {
      const pagingStyle = {
        sb: {
          first: 'pagination-link pagination-arrow-link',
          span: <span className="icon-chevron-left"></span>,
          last: 'pagination-link pagination-arrow-link'
        },
        hc: {
          first: 'pagination-link pagination-arrow-link',
          span: <span className="icon-chevron-left"></span>,
          last: 'pagination-link pagination-arrow-link',
          spanNext: <span className="icon-chevron-right"></span>
        },
        us: {
          first: 'pagination-link pagination-arrow',
          span: null,
          last: 'pagination-link pagination-arrow next',
          spanNext: null
        }
      }
      const totalPages = pagination.pages;
      const pageNumbers = [];
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }

      return (
        <ul role="navigation" aria-label="Pagination" className='pagination-links-row'>
          {currentPage > 1 && (
            <li className="previous">
              <a href={`${config.routes.articleList.path}?page=${currentPage - 1}`} className={pagingStyle[config.name].first} tabIndex="-1" role="button" aria-disabled="true" aria-label="Previous page" rel="prev">
                {pagingStyle[config.name].span} 
              </a>
            </li>
          )}

          {pageNumbers.map((pageNumber) => (
            <li key={`pge-${pageNumber}`}>
              <a href={`${config.routes.articleList.path}?page=${pageNumber}`} rel="canonical" role="button" tabIndex="-1" aria-label="Page 1 is your current page" aria-current="page" className={`pagination-link ${pageNumber === currentPage ? 'active' : ''}`}>{pageNumber}</a>
            </li>
          ))}

          {currentPage < totalPages && (
          <li className="next">
            <a href={`${config.routes.articleList.path}?page=${currentPage + 1}`} className="" tabIndex="0" role="button" aria-disabled="false" aria-label="Next page" rel="next" className={pagingStyle[config.name].last}>
              {pagingStyle[config.name].spanNext}
            </a>
          </li>
          )}
        </ul>
      )
    }
  }

  if (pagination.pages > 1) {
    return (
      <RenderPagination />
    )
  } else {
    return null
  }
}

Pagination.propTypes = {
  className: string,
  pagination: shape({
    next: any,
    pages: number,
    previous: any,
    total: any
  }),
  ...routerPropTypes
}

Pagination.displayName = 'Pagination'

export default Pagination
